/* eslint-disable react/display-name */

import './style.css'
import Polygon from '../../img/Polygon 5.png'
import successImage from '../../img/506644-middle.png'
import errorImage from '../../img/2914571-middle.png'

import React, { forwardRef, useState } from 'react'
import useFormLogic from '../../Helper/useFormLogic/useFormLogic'

const Form = forwardRef((_, ref) => {
  const {
    name,
    setName,
    phone,
    setPhone,
    email,
    setEmail,
    isAgreed,
    setIsAgreed,
    phoneInputRef,
    handleSubmit,
    errors,
    selectedCourse,
    setSelectedCourse,
    setRes,
    res,
  } = useFormLogic()

  const [isOpen, setIsOpen] = useState(false)
  const [message, setMessage] = useState('')

  const [messageType, setMessageType] = useState('')

  const options = [
    { value: '', label: 'Выберите курс', disabled: true },
    { value: 'Диалоги в комедии', label: 'Диалоги в комедии' },
    {
      value: 'Работа режиссера с актером, правила игры',
      label: 'Работа режиссера с актером. "Правила игры"',
    },
    { value: 'Киножанры', label: 'Киножанры' },
    {
      value: 'Производство коммерческого видео и рекламы',
      label: 'Производство коммерческого видео и рекламы',
    },
    {
      value: 'Особенности создания киносценария к жанровому кинофильму',
      label: 'Особенности создания киносценария к жанровому кинофильму',
    },

    {
      value: 'Продюсирование документального кино',
      label: 'Продюсирование документального кино',
    },

    {
      value: 'Основы Актерского Мастерства',
      label: 'Основы Актерского Мастерства',
    },
    {
      value: 'Основы Сценарного Мастерства',
      label: 'Основы Сценарного Мастерства',
    },
    {
      value: 'История кино от братьев Люмьер до XXI века',
      label: 'История кино от братьев Люмьер до XXI века',
    },

    { value: 'Киноклуб', label: 'Киноклуб' },
  ]

  const handleSelect = (value) => {
    setSelectedCourse(value)
    setIsOpen(false)
  }

  const handleSubmitCustom = async (event) => {
    event.preventDefault()
    handleSubmit(event)
  }

  React.useEffect(() => {
    if (res) {
      setMessage(res.message)
      setMessageType(res.status) // Сохраняем статус ответа
      setTimeout(() => {
        setMessage('')
        setMessageType('')
        setRes('')
      }, 5000)
    }
  }, [res])

  return (
    <>
      <section className="form center " ref={ref} id="form">
        <div className="form-bx">
          <h2 className="form-text">
            Оставьте заявку, чтобы получить консультацию или узнать
            больше&nbsp;о{' '}
            <span className="yellow-span yellow-span-txt">
              FREE&nbsp;SUN&nbsp;FILM&nbsp;SCHOOL
            </span>
          </h2>
          {message && (
            <div className="message-overlay">
              <div className="message-box">
                <div className="message-text">
                  {message}
                  {/* Отображаем картинку в зависимости от типа сообщения */}
                  {messageType === 'done' && (
                    <img
                      src={successImage}
                      alt="Success"
                      className="message-image"
                    />
                  )}
                  {messageType !== 'done' && (
                    <img
                      src={errorImage}
                      alt="Error"
                      className="message-image"
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          <form onSubmit={handleSubmitCustom} className="form-box">
            <input
              className={`form-box-data ${errors.name ? 'error-input' : ''}`}
              type="text"
              name="name"
              placeholder="ФИО"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {errors.name && (
              <span className="error-message">{errors.name}</span>
            )}
            <input
              className={`form-box-data ${errors.phone ? 'error-input' : ''}`}
              type="tel"
              name="phone"
              ref={phoneInputRef}
              placeholder="Номер телефона"
              data-tel-input
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            {errors.phone && (
              <span className="error-message">{errors.phone}</span>
            )}
            <input
              className={`form-box-data ${errors.email ? 'error-input' : ''}`}
              type="email"
              name="email"
              placeholder="E-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors.email && (
              <span className="error-message">{errors.email}</span>
            )}
            <div className="custom-select">
              <div
                className={`selected ${
                  errors.selectedCourse ? 'error-input' : ''
                }`}
                onClick={() => setIsOpen(!isOpen)}
              >
                {selectedCourse ? selectedCourse : 'Выберите курс'}
                <span className="arrow">&#9660;</span>
              </div>
              {isOpen && (
                <div className="options">
                  {options.map((option) => (
                    <div
                      key={option.value}
                      className={`option ${option.disabled ? 'disabled' : ''}`}
                      onClick={() =>
                        !option.disabled && handleSelect(option.value)
                      }
                    >
                      {option.label}
                    </div>
                  ))}
                </div>
              )}
              {errors.selectedCourse && (
                <span className="error-message">{errors.selectedCourse}</span>
              )}
            </div>
            <div className="form-checkbox">
              <input
                className={`form-checkbox-year ${
                  errors.isAgreed ? 'error-checkbox' : ''
                }`}
                type="checkbox"
                id="happy"
                name="isAgreed"
                value="yes"
                checked={isAgreed}
                onChange={(e) => setIsAgreed(e.target.checked)}
              />
              <label className="label-age" htmlFor="happy">
                Мне уже исполнилось 18 лет
              </label>
            </div>
            {errors.isAgreed && (
              <span className="error-message">{errors.isAgreed}</span>
            )}
            <div className="form-btn-container">
              <button className="form-btn" type="submit">
                Отправить заявку
              </button>
            </div>
          </form>
          <p className="form-pol">
            Нажимая кнопку «заполнить», вы соглашаетесь с&nbsp;политикой
            обработки персональных данных
          </p>
        </div>
      </section>
      <img className="polygon center-footer" src={Polygon} alt="" />
    </>
  )
})

export default Form
